import type { FreelancerFillInformationPageLocales } from '../types';

const freelancerFillInformationPageLocales: FreelancerFillInformationPageLocales =
  {
    checkboxMyself: 'Ik doe deze aanmelding namens mijzelf',
    checkboxTermsAndConditions1: 'Ik heb de ',
    checkboxTermsAndConditions2: ' gelezen en ga hiermee akkoord',
    checkboxTruthfully: 'Ik heb mijn aanmelding waarheidsgetrouw ingevuld',
    diplomasStep: 'Diploma’s & Certificaten',
    documentsStep: 'Documenten',
    headline:
      'Als je alle stappen hebt afgerond, kan je je aanmelding opsturen. Mocht je nog gegevens willen veranderen, doe dat dan nu.',
    headlineCompleted:
      'Gefeliciteerd met het afronden van je aanmelding. Kan je aangeven of de volgende dingen kloppen met je aanmelding?',
    kvkInformationStep: 'KVK inschrijving',
    personalInformationStep: 'Persoonlijke gegevens',
    stepCompleted: 'Compleet',
    stepNonCompleted: 'Nog niet gestart',
    submitApplication: 'Aanmelding Indienen',
    termsAndConditions: 'Algemene Voorwaarden',
    title: 'Aanmelden',
  };

export default freelancerFillInformationPageLocales;
